module.exports = __webpack_public_path__ + "0bc2ad0521aa019aff264d8a14fa8488.png";